import React from 'react';
import WhatsAppButton from '../WhatsAppButton';

// Extract clid from conversation_id
export const extractClid = (conversationId) => {
  if (conversationId && conversationId.includes('::')) {
    const parts = conversationId.split('::');
    if (parts.length >= 1) {
      return parts[0]; // clid is the first part
    }
  }
  return null;
};

// Get country code from region
// 852 for HK (Hong Kong), 65 for SG (Singapore)
export const getCountryCodeFromRegion = (region) => {
  if (!region) {
    return '852'; // Default to HK
  }

  const regionUpper = region.toUpperCase();
  if (regionUpper === 'HK' || regionUpper === 'HONG KONG') {
    return '852';
  } else if (regionUpper === 'SG' || regionUpper === 'SINGAPORE') {
    return '65';
  }

  // Default to HK if region is not recognized
  return '852';
};

// Detect 8-digit numbers in text
export const detectEightDigitNumbers = (text) => {
  if (!text || typeof text !== 'string') return [];
  // Match exactly 8 consecutive digits (not part of longer numbers)
  const regex = /\b(\d[\s-]?){7}\d\b/g;
  const matches = [];
  let match;
  while ((match = regex.exec(text)) !== null) {
    const number = match[0].replace(/\s/g, '').replace(/-/g, '');
    matches.push({
      number: number,
      index: match.index,
      length: number.length
    });
  }
  return matches;
};

// Render text with WhatsApp buttons/links for 8-digit numbers (only for CLID8855)
export const renderTextWithWhatsAppLinks = (conversationId, text, className = '', region = null) => {
  if (!text) {
    // For non-CLID8855 or empty text, just return the text as before
    return <>{text}</>;
  }

  // For CLID8855, detect 8-digit numbers and add WhatsApp links
  const numbers = detectEightDigitNumbers(text);

  if (numbers.length === 0) {
    // No 8-digit numbers found, return plain text
    return <>{text}</>;
  }

  // Get country code from region
  const countryCode = getCountryCodeFromRegion(region);

  // Split the text and insert WhatsApp links
  const parts = [];
  let lastIndex = 0;

  numbers.forEach((num, idx) => {
    // Add text before the number
    if (num.index > lastIndex) {
      parts.push(
        <React.Fragment key={`text-${idx}`}>
          {text.substring(lastIndex, num.index)}
        </React.Fragment>
      );
    }

    // Add the number as a clickable WhatsApp link
    const whatsappUrl = `https://wa.me/${countryCode}${num.number}`;
    const fullPhoneNumber = `${countryCode}${num.number}`;
    parts.push(
      <span key={`number-${idx}`} className="inline-flex items-center gap-1">
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800 hover:underline"
          title={`Open WhatsApp: ${fullPhoneNumber}`}
        >
          {num.number}
        </a>
      </span>
    );

    lastIndex = num.index + num.length;
  });

  // Add remaining text after the last number
  if (lastIndex < text.length) {
    parts.push(
      <React.Fragment key="text-end">
        {text.substring(lastIndex)}
      </React.Fragment>
    );
  }

  return <>{parts}</>;
};
